import React, { Component } from 'react'
import envUtil from '../utils/env.util'
import dateUtil from '../utils/date.util'
import Card from './Card'
import Icon from './Icon'
import Heading from './Heading'
import Bold from './Bold'
import { i18n } from "../i18n/i18n";

interface MaintenanceProps {}

export default class Maintenance extends Component<MaintenanceProps> {
  get duration () {
    const { maintenance } = envUtil
    return maintenance.duration &&
      <Bold text={maintenance.duration} />
  }

  get date () {
    const { maintenance } = envUtil
    return maintenance.date &&
      <Bold text={dateUtil.format(maintenance.date)} />
  }

  get description () {
    return (
      <div className="text-secondary">
        We are scheduled {this.duration} maintenance on {this.date} to improve our services. Thank you for your understanding!
      </div>
    )
  }

  render () {
    return envUtil.isMaintenanceScheduled &&
      <Card className="mb-4">
        <div className="inline-flex mb-1">
          <Icon
            name="cloud-off"
            size="medium"
            color="dark" />
          <Heading
            className="ml-2"
            text={i18n("Scheduled Maintenance")} />
        </div>
        {/* {i18n(this.description)} */}
        {i18n("We are scheduled 1 hour maintenance on Feb 20, 2020 3:00 PM to improve our services. Thank you for your understanding!")}
      </Card>
  }
}
